import React from 'react';
import ReactDOM from 'react-dom';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import App from './components/App';
import FallBackComponent from './FallbackComponent';

// Find all widget divs
const widgetDivs = document.querySelectorAll('.storable-webapps-onlinemovein');

// eslint-disable-next-line import/prefer-default-export
export const bugsnagClient = Bugsnag.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.BUGSNAG_ENVIRONMENT,
});

BugsnagPerformance.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  bugsnag: bugsnagClient,
});

const BugSnagErrorBoundary = bugsnagClient
  .getPlugin('react')
  .createErrorBoundary(React);

const getUpdatedReservationId = (reservationId) => {
  const parts = reservationId?.split(';') || [];
  const initialParts = parts[0]?.split(':') || [];
  initialParts[initialParts.length - 1] = `${initialParts[initialParts.length - 1]}`.toUpperCase();
  return [initialParts.join(':'), `${parts[1]}`.toUpperCase(), ...parts.slice(2)].join(';');
};

// Inject our React App into each class
widgetDivs.forEach((div) => {
  const finalDataset = { ...div.dataset };
  if (finalDataset.providerId === 'sl' || finalDataset.providerId === 'SL') {
    finalDataset.organizationId = `${finalDataset.organizationId}`.toUpperCase();
    finalDataset.facilityId = `${finalDataset.facilityId}`.toUpperCase();
    finalDataset.reservationId = getUpdatedReservationId(finalDataset.reservationId);
  }
  ReactDOM.render(
    <React.StrictMode>
      <BugSnagErrorBoundary
        onError={(ev) => {
          ev.addMetadata('omi-widget', finalDataset);
        }}
        FallbackComponent={FallBackComponent}
      >
        <App {...finalDataset} />
      </BugSnagErrorBoundary>
    </React.StrictMode>,
    div,
  );
});

// const injectApp = (params) => {
//   const container = document.getElementById('storable-webapps-onlinemovein');
//   const root = ReactDOM.createRoot(container);

//   root.render(
//     <React.StrictMode>
//       <App params={params} />
//     </React.StrictMode>,
//   );
// };

// const ONLINE_MOVE_IN = {
//   initialize: (params) => injectApp(params),
// };

window.STORABLE_WEBAPPS = {
  ...(window.STORABLE_WEBAPPS || {}),
};
